/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FarmDto } from '../../models/farm-dto';

export interface FarmControllerDelete$Params {
  id: string;
}

export function farmControllerDelete(http: HttpClient, rootUrl: string, params: FarmControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmDto>> {
  const rb = new RequestBuilder(rootUrl, farmControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FarmDto>;
    })
  );
}

farmControllerDelete.PATH = '/api/farm/{id}';
